// extracted by mini-css-extract-plugin
export var category = "_jt-9";
export var categoryHeader = "_jt-e";
export var container = "_jt-0";
export var group = "_jt-a";
export var groupItems = "_jt-f";
export var groupSeparator = "_jt-j";
export var loading = "_jt-1";
export var noResults = "_jt-3";
export var placeholder = "_jt-2";
export var resultContent = "_jt-5";
export var resultIcon = "_jt-c";
export var resultItem = "_jt-g";
export var resultMeta = "_jt-8";
export var resultSubtitle = "_jt-7";
export var resultSuffix = "_jt-i";
export var resultTitle = "_jt-6";
export var resultsList = "_jt-4";
export var searchGroup = "_jt-d";
export var selected = "_jt-h";
export var subgroup = "_jt-b";